import React from 'react';
import { Link } from 'react-router-dom';

const MidPageCTA: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-12 border-2 border-blue-200">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ready to Replace Your Entire Software Stack?
          </h3>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Join thousands of businesses saving 70% on software costs while gaining access to 23 interconnected AI tools.
          </p>
          
          {/* Dual CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/signup"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl"
            >
              Try Free — Build Smarter
              <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-blue-600 bg-white border-2 border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
            >
              Compare Plans
            </Link>
          </div>

          <p className="mt-6 text-sm text-gray-600">
            ✨ 7-day free trial • Full access to all features • Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
